export default {
  生产物料: "Production Materials",
  非生产物料: "Non-Production Materials",
};
